import React from "react";
import "./styles.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-heading">Social Links</div>
      <ul className="footer-pills">
        <li className="list-item-inline">
          <a className="link" href="https://www.linkedin.com/in/ravikumar0403/">
            Linkedin
          </a>
        </li>
        <li className="list-item-inline">
          <a className="link" href="https://github.com/ravikumar0403">
            Github
          </a>
        </li>
        <li className="list-item-inline">
          <a className="link" href="https://twitter.com/ravikumar0403">
            Twitter
          </a>
        </li>
      </ul>
    </footer>
  );
};

export default Footer;
